import { useCallback, useEffect } from "react";
import { nextInput } from "@shared/utils/navigation/nextInput";

const INTERACTIVE_TAGS = new Set(["BUTTON", "A"]);

function isInteractiveElement(): boolean {
  const active = document.activeElement;
  return INTERACTIVE_TAGS.has(active?.tagName ?? '') || active?.role === "listbox";
}

function handleEnterKey(event: KeyboardEvent) {
  if (event.shiftKey) return;
  if (isInteractiveElement()) return;
  nextInput(event);
}

function handleEscapeKey(back: Function) {
  back();
}

export function useFormKeyboardNavigation(back?: Function) {
  const handleKeyboardEvent = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        handleEnterKey(event);
      }
      if (event.key === "Escape" && back) {
        handleEscapeKey(back);
      }
    },
    [back]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyboardEvent);
    return () => {
      document.removeEventListener("keydown", handleKeyboardEvent);
    };
  }, [handleKeyboardEvent]);
}
